import type { Icons } from '@/components/base/BaseIcon.vue'

const REWARD_TYPE_ICONS: Record<string, Icons> = {
  free_product: 'HeroGiftIconOutline',
  voucher_discount_percent: 'HeroReceiptPercentIconSolid',
  product_discount_percent: 'HeroReceiptPercentIconSolid',
  voucher_discount_amount: 'HeroCurrencyEuroIconOutline',
  product_discount_amount: 'HeroCurrencyEuroIconOutline',
  voucher_free_delivery: 'HeroArrowPathIconOutline',
  voucher_x_for_y: 'HeroShoppingBagIconOutline',
  lost: 'HeroXMarkIconOutline',
  points: 'HeroCircleStackIconOutline'
}

export const getRewardTypeIcon = (rewardType?: { slug: string; name: string }): Icons => {
  if (!rewardType) return 'HeroGiftIconOutline'
  return REWARD_TYPE_ICONS[rewardType.slug] || 'HeroGiftIconOutline'
}

export const getRewardTypeLabel = (rewardType: { slug: string; name: string }, t: (key: string) => string): string => {
  if (!rewardType) return '-'

  const labelMap: Record<string, string> = {
    free_product: t('pages.reward.library.type.freeProduct'),
    voucher_discount_percent: t('pages.reward.library.type.discountPercent'),
    product_discount_percent: t('pages.reward.library.type.productDiscountPercent'),
    voucher_discount_amount: t('pages.reward.library.type.discountAmount'),
    product_discount_amount: t('pages.reward.library.type.productDiscountAmount'),
    voucher_free_delivery: t('pages.reward.library.type.freeDelivery'),
    voucher_x_for_y: t('pages.reward.library.type.xForY'),
    points: t('pages.contests.buttons.points'),
    lost: t('pages.contests.buttons.lost')
  }

  return labelMap[rewardType.slug] || rewardType.name
}
